module.exports = __webpack_public_path__ + "static/media/lora_modbus.875005b4.md";